import { render, staticRenderFns } from "./VvRichText.vue?vue&type=template&id=16b426e2&"
import script from "./VvRichText.vue?vue&type=script&lang=js&"
export * from "./VvRichText.vue?vue&type=script&lang=js&"
import style0 from "./VvRichText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports